import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AuthenticationService} from '../../../../../services/authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ProcessService} from '../../../../../services/user-services/process.service';
import {finalize, first} from 'rxjs/operators';
import {AlertService} from '../../../../../services/alert.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../../services/user-services/user.service';
import {User} from '../../../../../models/user';
import {Alert} from '../../../../../models/alert';
import {AccommodationService} from '../../../../../services/accommodation.service';
import {FilterContentComponent} from '../component-filter-modal/filter-content/filter-content.component';
import {AccommodationCityInputComponent} from '../accommodation-city-input/accommodation-city-input.component';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormLoginComponent} from '../../../../../shared/components/forms/login-register/form-login.component';
import {IconComponent} from '../../../../../shared/components/icons-svgs/icons-svgs.component';
import {DatePipe, NgClass, NgIf} from '@angular/common';

@Component({
  selector: 'app-accommodation-alerts',
  templateUrl: './accommodation-alerts.component.html',
  styleUrls: ['./accommodation-alerts.component.scss'],
  imports: [NgIf, NgClass, IconComponent, FormLoginComponent, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, AccommodationCityInputComponent, FilterContentComponent, TranslateModule],
  standalone: true,
  providers: [
    DatePipe,
  ]
})
export class AccommodationAlertsComponent implements OnInit, AfterViewInit {

  @Input() public showText: boolean = true;
  @Output() public updatedAlert: EventEmitter<any> = new EventEmitter<any>();
  // Récupère tous les filtres, qu'ils aient été pré-set ou fait dans la modale
  @Input() public filters: any = {
    minPrice: null,
    maxPrice: null,
    minMeter: null,
    maxMeter: null,
    wc: null,
    bathrooms: null,
    tenants_gender: [],
    duration: [],
    type: [],
    tenants: [],
    empty_rooms: [],
    arrivalDate: null,
    departureDate: null,
    durationDate: null,
  };
  @Input() public isUpdate: boolean = false;
  @Input() public selectedAlert: Alert;
  @Input() public wantedCity;

  public isLogged: boolean = false;
  // Récupère le nom de l'alerte, si null, on en met un nous même
  public alertNameFormControl: FormControl<string | null> = new FormControl();
  public locale: string = 'en';
  public isMobile: boolean = false;
  // True quand submit et qu'il n'y a pas de soucis avec l'envoi en base
  public isAlertCreated: boolean = false;


  public modaleTitle: string = 'PROCESSES.ALERTS.ACCOMMODATION.TITLE';
  @ViewChild('alert_modale') alertModale;
  public isSubmit: boolean = false;
  public user: User;
  public alertFilters;

  constructor(
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private userProcessService: ProcessService,
    private alertService: AlertService,
    private _translateService: TranslateService,
    private userService: UserService,
    private routerService: Router,
    private accommodationService: AccommodationService,
    private datePipe: DatePipe,
  ) {
  }


  ngOnInit(): void {
    this.alertFilters = {...this.filters};
    this.isMobile = this.userService.isMobileUser;
    if (this.authenticationService.currentUserValue) {
      this.isLogged = true;
    }
    this.getCity(this.selectedAlert?.city, true);
    this.user = this.userService.userInformations;
  }

  ngAfterViewInit(): void {
    if ((window.location.hash === '#reload' && !this.modalService.hasOpenModals()) || this.isUpdate) {
      this.openModale(this.alertModale);
      this.route.queryParams.pipe(first()).subscribe(param => {
        if (param) {
          const keysArray = Object.keys(param);
          keysArray.forEach(key => {
            this.alertFilters[key] = param[key];
          });
        }
      });
      history.replaceState('', document.title, window.location.pathname + window.location.search);
    }
    if (this.isUpdate) {
      this.modaleTitle = 'PROCESSES.ALERTS.PROFILE.FORM.TITLE';
      if (this.selectedAlert) {
        this.setAlertFilters();
      }
    }
  }

  public setAlertFilters(): void {
    this.alertNameFormControl.setValue(this.selectedAlert.name);
    this.selectedAlert.datas.forEach(data => {

      if (data.type === 'price' || data.type === 'surface') {
        const split = data.value.split(' ');
        if (split && split.length > 0) {
          if (data.type === 'price') {
            this.alertFilters.minPrice = split[0];
            this.alertFilters.maxPrice = split[2];
          } else {
            this.alertFilters.minMeter = split[0];
            this.alertFilters.maxMeter = split[2];
          }
        }
      } else {
        if (data.type === 'dates') {
          if (data.value && data.value.trim().length > 0) {
            const split = data.value.split('/');
            if (split[0].trim()) {
              this.alertFilters.arrivalDate = split[0].trim();
            }
            if (split[1].trim()) {
              this.alertFilters.departureDate = split[1].trim();
            }
          }
        }
        this.alertFilters[data.type] = data.value;
      }
    });
  }

  public openModale(name): void {
    this.resetModale();
    this.isSubmit = false;
    this.modalService.open(name, {centered: true, size: 'lg'});
  }

  public submit(): void {
    if (this.wantedCity) {
      this.isSubmit = true;
      let dates = this.alertFilters.arrivalDate ? this.alertFilters.arrivalDate + ' / ' : ' / ';
      dates += this.alertFilters.departureDate ? this.alertFilters.departureDate : '';

      const datas = {
        type: this.alertFilters.type,
        price: this.alertFilters.minPrice || this.alertFilters.maxPrice ? (this.alertFilters.minPrice + ' - ' + this.alertFilters.maxPrice) : null,
        duration: this.alertFilters.duration,
        surface: this.alertFilters.minMeter || this.alertFilters.maxMeter ? (this.alertFilters.minMeter + ' - ' + this.alertFilters.maxMeter) : null,
        bathrooms: this.alertFilters.bathrooms,
        wc: this.alertFilters.wc,
        tenants: this.alertFilters.tenants,
        empty_rooms: this.alertFilters.empty_rooms,
        tenants_gender: this.alertFilters.tenants_gender,
        noWarrant: this.alertFilters.noWarrant,
        dates: dates,
        durationDate: this.alertFilters.durationDate
      };
      if (!this.isUpdate) {
        this.createAlert(datas);
      } else {
        this.updateAlert(datas);
      }
    }
  }

  // Récupère la ville si l'utilisateur la change
  public getCity(event, onInit ?): void {
    if (onInit) {
      if (this.route.snapshot.firstChild) {
        this.wantedCity = this.route.snapshot.firstChild.paramMap.get('city');
      } else {
        if (this.selectedAlert) {
          this.wantedCity = this.selectedAlert.city;
        } else {
          if (!this.wantedCity) {
            this.wantedCity = 'Lille';
          }
        }
      }
    } else {
      this.wantedCity = event;
    }
  }

  public resetFilters(): void {
    this.alertFilters = {
      minPrice: null,
      maxPrice: null,
      minMeter: null,
      maxMeter: null,
      wc: null,
      bathrooms: null,
      tenants_gender: [],
      duration: [],
      type: [],
      tenants: [],
      empty_rooms: [],
      arrivalDate: null,
      departureDate: null,
      durationDate: null,
    };
    if (this.isUpdate) {
      const defaultType = this.selectedAlert.datas.find(a => a.type === 'type');
      this.alertFilters.type = defaultType.value;
    } else {
      this.getCity(null, true);
    }
  }

  private createAlert(datas): void {
    this.accommodationService.createAlert({
      name: this.alertNameFormControl.value,
      datas,
      city: typeof this.wantedCity == 'string' ? this.wantedCity : this.wantedCity.id
    })
      .pipe(first(),
        finalize(() => {
          this.isSubmit = false;
        }))
      .subscribe((result: any) => {
        this.openSnackBar(result.status);
        if (result.status === 'success') {
          this.isAlertCreated = true;
          this.modaleTitle = 'PROCESSES.ALERTS.ACCOMMODATION.VALIDATED.TITLE';
        }
      });
  }

  private updateAlert(datas): void {
    this.accommodationService.updateAlert({
      name: this.alertNameFormControl.value,
      datas,
      city: typeof this.wantedCity == 'string' ? this.wantedCity : this.wantedCity.id
    }, this.selectedAlert.id).pipe(first(),
      finalize(() => {
        this.isSubmit = false;
      }))
      .subscribe((result: any) => {
        this.openSnackBar(result.status);
        if (result.alert) {
          this.updatedAlert.emit(result.alert);
          this.modalService.dismissAll();
        }

      });
  }

  private openSnackBar(resultStatus: string): void {
    let msg;
    if (resultStatus === 'success') {
      msg = 'OK';
    } else {
      msg = this._translateService.instant('COMMON.TRY_LATER');
    }
    this.alertService.openSnackBar(msg, resultStatus);
  }

  public goToProfile(): void {
    this.modalService.dismissAll();
    if (this.routerService.url.includes('/account/my-profile')) {
      window.location.reload();
    }
    this.routerService.navigate(['/account/my-profile']);
  }

  public getAlertFilters(filters): void {
    this.alertFilters = filters;
  }

  private resetModale(): void {
    this.isAlertCreated = false;
    this.alertNameFormControl.setValue(null);
    this.modaleTitle = 'PROCESSES.ALERTS.ACCOMMODATION.TITLE';
    if (this.filters) {
      this.alertFilters = {...this.filters};
    }
  }

}
